import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { SUPPORTED_LANGUAGES } from "@/lib/translations";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe, Check } from "lucide-react";

const LABELS = { pt: "PT-BR", en: "EN", fr: "FR" };
const FULL = { pt: "Português", en: "English", fr: "Français" };

const LanguageSwitcher = () => {
  const { lang, setLang } = useLanguage();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="language-switcher"
        className="inline-flex items-center gap-2 rounded-full border border-[#e5e3db] bg-white/70 px-3 py-1.5 text-xs font-medium text-[#1e2a5a] backdrop-blur-md transition-colors hover:border-[#1e2a5a] focus:outline-none focus:ring-2 focus:ring-[#1e2a5a]/10"
      >
        <Globe className="h-3.5 w-3.5" strokeWidth={1.75} />
        <span className="tracking-wider">{LABELS[lang]}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="min-w-[170px] border-[#e5e3db] bg-white text-[#1e2a5a]"
      >
        {SUPPORTED_LANGUAGES.map((code) => (
          <DropdownMenuItem
            key={code}
            data-testid={`language-option-${code}`}
            onClick={() => setLang(code)}
            className="flex items-center justify-between font-body text-sm"
          >
            <span>{FULL[code]}</span>
            {lang === code ? <Check className="h-3.5 w-3.5 text-[#d9381e]" /> : null}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
